import React from "react";

export function Logo({ size = "md", withSub = true, className = "" }) {
  const sizes = {
    sm: { c: "text-2xl", r: "text-lg", sub: "text-[7px]" },
    md: { c: "text-4xl", r: "text-2xl", sub: "text-[9px]" },
    lg: { c: "text-6xl", r: "text-4xl", sub: "text-xs" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex flex-col ${className}`} data-testid="app-logo">
      <div className="flex items-end gap-2 leading-none">
        <span className={`font-display font-black tracking-tight ${s.c}`}>
          <span className="bg-gradient-to-br from-blue-500 to-emerald-400 bg-clip-text text-transparent">C</span>
          <span className="bg-gradient-to-br from-amber-300 to-yellow-400 bg-clip-text text-transparent">E</span>
          <span className="bg-gradient-to-br from-orange-500 to-red-500 bg-clip-text text-transparent">P</span>
        </span>
        <span className={`font-display font-extrabold tracking-tight text-slate-100 ${s.r}`}>RADIOSAFE</span>
      </div>
      {withSub && (
        <span className={`mt-1 font-medium uppercase tracking-[0.25em] text-slate-500 ${s.sub}`}>
          Radioprotection et Physique Médicale
        </span>
      )}
    </div>
  );
}
